var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-2 -2 24 24",
    width: 24,
    height: 24,
    preserveAspectRatio: "xMinYMin",
    className: "icon__icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 18h18a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2zM3 8h2a1 1 0 0 1 1 1v8H2V9a1 1 0 0 1 1-1zm5-4h2a1 1 0 0 1 1 1v12H7V5a1 1 0 0 1 1-1zm5 6h2a1 1 0 0 1 1 1v6h-4v-6a1 1 0 0 1 1-1zm5-8h2a1 1 0 0 1 1 1v14h-4V3a1 1 0 0 1 1-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.dc38e0a3.svg";
export { ForwardRef as ReactComponent };